// extracted by mini-css-extract-plugin
export default {"progress":"ProgressBar_progress__FEQ3-","current":"ProgressBar_current__mwlmc"};